import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard, Building2, Users, Globe, ShieldCheck,
  Server, ListTodo, Settings, LogOut, ChevronLeft, DollarSign
} from 'lucide-react';
import { trackCTAClick } from '../lib/gtag';
import { CertiniteBrandLink } from './CertiniteBrand';

export default function AdminLayout() {
  const { logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { name: 'Dashboard', path: '/controlpanel', icon: LayoutDashboard },
    { name: 'Tenants', path: '/controlpanel/tenants', icon: Building2 },
    { name: 'Users', path: '/controlpanel/users', icon: Users },
    { name: 'Fiyat yönetimi', path: '/controlpanel/pricing', icon: DollarSign },
    { name: 'Domains', path: '/controlpanel/domains', icon: Globe },
    { name: 'Certificates', path: '/controlpanel/certificates', icon: ShieldCheck },
    { name: 'Agents', path: '/controlpanel/agents', icon: Server },
    { name: 'Jobs', path: '/controlpanel/jobs', icon: ListTodo },
    { name: 'Settings', path: '/controlpanel/settings', icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-dark-900 flex text-gray-200 font-sans">
      <aside className="w-72 bg-dark-800 border-r border-dark-700 flex flex-col shrink-0">
        <div className="flex h-16 min-w-0 items-center gap-2 border-b border-dark-700 px-4">
          <CertiniteBrandLink to="/controlpanel" variant="onDark" size="sm" className="min-w-0 flex-1 drop-shadow-md" />
          <span className="shrink-0 rounded px-2 py-0.5 text-xs font-bold uppercase tracking-wider bg-rose-500/20 text-rose-400">Admin</span>
        </div>

        <nav className="flex-1 px-3 py-5 space-y-1 overflow-y-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link key={item.name} to={item.path} onClick={() => trackCTAClick('admin_sidebar', item.path, item.name)}
                className={`flex items-center px-4 py-2.5 rounded-xl text-sm font-medium transition-all ${
                  isActive
                    ? 'bg-primary-600/15 text-primary-400'
                    : 'text-gray-400 hover:bg-dark-700 hover:text-gray-200'
                }`}
              >
                <Icon className={`w-5 h-5 mr-3 ${isActive ? 'text-primary-400' : 'text-gray-500'}`} />
                {item.name}
              </Link>
            );
          })}
        </nav>

        <div className="p-3 border-t border-dark-700 space-y-1">
          <Link to="/dashboard"
            className="flex items-center w-full px-4 py-2.5 text-sm font-medium text-gray-400 rounded-xl hover:bg-dark-700 hover:text-gray-200 transition-colors">
            <ChevronLeft className="w-5 h-5 mr-3" />
            Back to Dashboard
          </Link>
          <button onClick={logout}
            className="flex items-center w-full px-4 py-2.5 text-sm font-medium text-gray-400 rounded-xl hover:bg-rose-500/10 hover:text-rose-400 transition-colors">
            <LogOut className="w-5 h-5 mr-3" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <header className="h-16 bg-dark-800/50 backdrop-blur-md border-b border-dark-700 flex items-center justify-between px-8 sticky top-0 z-10">
          <h1 className="text-lg font-semibold text-gray-100">
            Control Panel
          </h1>
          <div className="flex items-center space-x-3">
            <span className="text-xs px-2.5 py-1 bg-emerald-500/15 text-emerald-400 rounded-full font-semibold border border-emerald-500/20">System Admin</span>
          </div>
        </header>
        <div className="flex-1 overflow-auto p-8">
          <div className="max-w-7xl mx-auto">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
